module.exports = __webpack_public_path__ + "static/img/403-Version2.d5325f2.svg";